<app-admin-header *ngIf="!fromTraining" [header]="showingSelectUser ? assignUserHeader : header" [links]="showingSelectUser ? [] : links"
  [breadcrumbs]="showingSelectUser ? assignUserBreadcrumbs : breadcrumbs" [stats]="stats" [queryParams]="queryParams"
  (backClicked)="saveDraft()"></app-admin-header>
<app-assign-users [selectionData]="survey.attendees" [query]="userQuery" (selectedUsersList)="addAttendees($event)"
  [userFetchUrl]="'user/get'" *ngIf="showingSelectUser"></app-assign-users>
<p-toast />
<p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
<div *ngIf="autoQuestionAdded > 0" class="alert alert-success">
  <i class="pi pi-check success-icon"></i>
  {{ "تم إضافة " + autoQuestionAdded + " أسئلة بنجاح" }}
</div>

<div *ngIf="autoQuestionAdded == 0" class="alert alert-danger">
  <i class="pi pi-times-circle error-icon"></i>
  {{ 'No Question Added based on applied filters' | translator }}
</div>

<div *ngIf="correctError" class="alert alert-danger">
  <i class="pi pi-times-circle error-icon"></i>
  {{ "Please Select Correct Answers of Following Questions" | translator }}
</div>

<div *ngIf="labelError" class="alert alert-danger">
  <i class="pi pi-times-circle error-icon"></i>
  {{
  "Please Add Question Text & Option Label of Following Questions"
  | translator
  }}
</div>
<div *ngIf="totalError" class="alert alert-danger">
  <i class="pi pi-times-circle error-icon"></i>
  {{ "Sum of Questions Marks are not Equal to Total Marks" | translator }}
</div>
<app-skelitions [hidden]="!skelition" [value]="2" class="mb-2"></app-skelitions>
<div class="container-fluid" *ngIf="!showingSelectUser && !skelition">
  <div class="d-flex justify-content-start" *ngIf="!skelition">
    <div class="container-fluid v4-bg-img">
      <div class="d-flex justify-content-center w-100">
        <div class="row w-100">
          <div class="{{sidebarVisible ?'col-md-7 col-12 p-1' :'col-md-12 col-12 p-1' }}">
            <div class="d-flex">
              <div class="d-flex justify-content-end w-100 question-ov-flow-2">
                <div class="card q-pro-card">
                  <div *ngIf="!isTopic" class="d-flex justify-content-center w-h-100 position-relative">
                    <img *ngIf="survey.headerImage" class="logo-img" src="{{
                        survey.headerImage ? staticFileUrl + survey.headerImage : ''
                      }}" />

                    <img *ngIf="!survey.headerImage" class="logo-img align-self-center"
                      src="../../../../../assets/rectangle-32.png" />
                    
                    <!-- Change image icon overlay -->
                    <button class="btn change-image-btn position-absolute top-0 end-0 m-2" 
                            pTooltip="{{ 'Add a logo' | translator }}" 
                            tooltipPosition="top" 
                            (click)="pickImage()">
                      <img class="change-image-icon" 
                           src="../././../../.././../assets/icones-2025/imageplaceholder.png" 
                           alt="Change image">
                    </button>
                  </div>
                  <div class="d-flex justify-content-start gap-2 py-3 w-100 1111">
                    <div class="w-100">
                      <input pInputText class="q-input-white" placeholder="Name" [(ngModel)]="survey.name" type="text"
                        pInputText />
                    </div>
                    <div class="w-100">
                      <input pInputText *ngIf="tags != undefined && isAssessment" class="q-input-white"
                        [value]="tags[0].arabic" type="text" [readonly]="true" />
                    </div>
                    <div class="w-100">
                      <input pInputText *ngIf="tags != undefined && isSurvey" class="q-input-white" [value]="tags.name"
                        type="text" [readonly]="true" />
                    </div>
                  </div>
                  <div class="d-flex justify-content-start mt-2" *ngIf="isTopic">
                    <p-editor plainTextPaste class="question-p-editor-white w-100 333" [(ngModel)]="survey.description"
                      [style]="{ height: '320px' }"></p-editor>
                  </div>
                  <div class="d-flex justify-content-start my-3"
                    *ngIf="isTopic && survey.service && survey.service !== ''">
                    <button class="v4-btn-every 111" (click)="launchUrl(survey.service)"><i
                        class="pi pi-external-link"></i>{{ 'Service' | translator }}</button>
                  </div>
                  <div class="bg-content">
                    <div *ngIf="isAssessment" class="row">
                      <div class="col-md-3 col-12">
                        <div class="d-flex column w-100">
                          <span class="ans-color mb-2">{{ "Total Marks" | translator }}</span>
                          <p-inputNumber inputId="integeronly" class="q-input-number"
                            placeholder="{{ 'Total Marks' | translator }}" [(ngModel)]="survey.totalMarks" />
                        </div>
                      </div>
                      <div class="col-md-3 col-12">
                        <div class="d-flex column w-100" *ngIf="isAssessment">
                          <span class="ans-color mb-2">{{ "Default Score" | translator }}</span>
                          <p-inputNumber inputId="integeronly" class="q-input-number"
                            placeholder="{{ 'Default Score' | translator }}" [(ngModel)]="survey.defaultScore" />
                        </div>
                      </div>
                      <div class="col-md-3 col-12">
                        <div class="d-flex column w-100" *ngIf="survey.accessType!='POPUP'">
                          <span class="ans-color mb-2">{{ "Attempt Time (mintues)" | translator }}</span>
                          <p-inputNumber inputId="integeronly" class="q-input-number"
                            placeholder="{{ 'Attempt Time (mintues)' | translator }}"
                            [(ngModel)]="survey.attemptTime"
                            [min]="1"
                            [max]="240" />
                        </div>
                      </div>
                      <div class="col-md-3 col-12">
                        <div class="d-flex column w-100" *ngIf="survey.accessType!='POPUP'">
                          <span class="ans-color mb-2">{{ "Total Participant" | translator }}</span>
                          <p-inputNumber inputId="integeronly" class="q-input-number"
                            placeholder="{{ 'Total Participant' | translator }}"
                            [(ngModel)]="survey.totalParticipant" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex justify-content-center" *ngIf="
                      isTopic ||
                      isSurvey ||
                      (isAssessment && getSumOfQuestionMarks() < survey.totalMarks)
                    ">
                    <button class="btn add-question mob-view mb-3" *ngIf="!sidebarVisible"
                      (click)="isImpactSurvey == true ? addQuestion(impactQuestion,true, false) : openSidebar(-1)">
                      {{ "Add a question" | translator }}
                    </button>
                  </div>
                  <!-- Second i should be replaced with editingIndex after implementing recognizing mechonizam -->
                  <div class="mb_20" *ngFor="let question of survey.questions; let i = index">
                    <!-- <div> -->
                    <app-questions-edit (click)="setCurrentEditQuestion(i)"
                      [disabled]="canConditional(question) || canLinked(question)" [editingIndex]="editingIndex"
                      [conditionalQuestions]="conditionalQuestions" [linkedQuestions]="linkedQuestions"
                      [question]="question" [disableLinkedOptions]="disableLinkedOptions" [questionIndex]="i"
                      [removeQuestion]="removeQuestion" [disableConditionalOptions]="disableConditionalOptions"
                      [getConditionalOptions]="getConditionalOptions" [isAssessment]="isAssessment" [isTopic]="isTopic"
                      [survey]="survey" [fromTraining]="fromTraining" (saveProgress)="saveProgress()"
                      [isConditional]="canConditional(question)" [isLinked]="canLinked(question)"
                      [isImpactSurvey]="isImpactSurvey" [UserExternalFields]="false"
                      [difficultyLevels]="difficultyLevels" [ouTreeOptions]="ouTreeOptionsForQuestions" [availableOuTreeTags]="availableOuTreeTags"></app-questions-edit>
                    <!-- position under bar with buttons custom code start -->
                    <div class="pos-rel">
                      <div *ngIf="false" class="pos-abs">
                        <button (click)="changeSeparator(question, i)" class="btn page-break-btn {{
                              question.separator ? 'bg-primary text-light' : ''
                            }}">
                          {{ "separator" | translator }}
                          <i class="pi pi-check-square font-11"></i>
                        </button>
                        <button (click)="changePageBreak(question, i)" class="btn page-break-btn mx-2 {{
                              question.pageBreak ? 'bg-primary text-light' : ''
                            }}">
                          {{ "break" | translator }} {{ "the page" | translator }}
                          <i class="fa fa-chain-broken"></i>
                        </button>
                      </div>
                      <div class="flex-center my-3 gap-2">
                        <!-- <button  *ngIf="isTopic || isSurvey || (isAssessment && getSumOfQuestionMarks() < survey.totalMarks)" class="btn add-question" (click)="isImpactSurvey == true ? addQuestion(impactQuestion,true, false) : openSidebar(i)">
                            {{ "Add a question" | translator }}
                          </button> -->
                        <!-- <button class="btn add-logo-2" target="_blank" *ngIf="!isTopic"
                            (click)="gotoUrl('/sa/' + from + '/attempt/' + survey._id, '', true)">
                            {{ "an offer" | translator }}
                          </button> -->
                      </div>
                    </div>
                    <!-- </div> -->
                  </div>
                  <!-- footer -->
                  <div *ngIf="!isTopic && survey.footerText" class="flex-start py-2 px-2 w-100">
                    <p class="color-grey" [innerHTML]="survey.footerText | safeHTML"></p>
                  </div>
                  <div *ngIf="!isTopic" class="d-flex justify-content-center w-100 py-4 top-dashed"
                    style="align-self: center">
                    <button class="btn add-logo-2" (click)="openTextModal(false)">
                      {{ "Thank you the text of the page" | translator }}
                    </button>
                    <button class="btn add-logo-2 mx-2" (click)="openTextModal(true)">
                      {{ "Edit footer" | translator }}
                    </button>
                  </div>
                  <div class="w-100 d-flex justify-content-center flex-wrap gap-2">
                    <!-- Regular flow: single save -->
                    <button *ngIf="!fromTrainingInput" (click)="publishSurvey()" class="btn add-question">
                      {{ "save" | translator }}
                    </button>
                    <!-- Training flow: explicit draft / publish (these close the builder) -->
                    <button *ngIf="fromTrainingInput" (click)="saveDraftAndExit()" class="btn add-logo-2">
                      {{ "Save as draft" | translator }}
                    </button>
                    <button *ngIf="fromTrainingInput" (click)="publishAndExit()" class="btn add-question">
                      {{ "Save and publish" | translator }}
                    </button>
                  </div>
                  <!-- footer end -->
                </div>
              </div>
              <div class="d-f-btn-bar m-r-2">
                <button pTooltip="{{ 'Rearrangement' | translator }}" tooltipPosition="right" class="btn add-logo"
                  (click)="openReorderableModal()">
                  <img class="add-btn-img" src="../././../../.././../assets/icones-2025/swap.png" alt="loading">
                </button>
                <button pTooltip="{{ 'Settings' | translator }}" tooltipPosition="right" class="btn add-logo"
                  *ngIf="!isTopic" (click)="openSettingsModal = true">
                  <img class="add-btn-img" src="../././../../.././../assets/icones-2025/settings.png" alt="loading">
                </button>
                <button pTooltip="{{ 'Add external users' | translator }}" tooltipPosition="right"
                  [hidden]="survey.accessType=='POPUP'" class="btn add-logo" *ngIf="!isTopic"
                  (click)="openAddExternalModal = true">
                  <img class="add-btn-img" src="../././../../.././../assets/icones-2025/person.png" alt="loading">
                </button>
                <!-- && survey.questionBankId != this.standardQBID-->
                <button pTooltip="{{ 'Select service' | translator }}" tooltipPosition="right" class="btn add-logo"
                  *ngIf="isTopic && survey.type == 'Service'" (click)="showSelectServiceModal = true">
                  <img class="add-btn-img" src="../././../../.././../assets/icones-2025/building.png" alt="loading">
                </button>
                <button pTooltip="{{ 'Add a logo' | translator }}" tooltipPosition="right" class="btn add-logo"
                  *ngIf="!isTopic" (click)="pickImage()">
                  <img class="add-btn-img" src="../././../../.././../assets/icones-2025/imageplaceholder.png"
                    alt="loading">
                </button>
                <button pTooltip="{{ 'Add participants' | translator }}" tooltipPosition="right"
                  *ngIf="survey.accessType == 'BY_ACCOUNT' && !isTopic" class="btn add-logo"
                  (click)="showingSelectUser = true">
                  <img class="add-btn-img" src="../././../../.././../assets/icones-2025/group_add.png" alt="loading">
                </button>
                <button *ngIf="
                    survey?.type?.requiredAttendance && !isAssessment && !isTopic
                  " (click)="gotoUrl('/survey/attendance', survey._id, false)" class="btn add-logo">

                  <img pTooltip="{{ 'Attendance' | translator }}" tooltipPosition="right" class="add-btn-img"
                    src="../././../../.././../assets/icones-2025/attendance.png" alt="loading">
                </button>
                <button *ngIf="(isAssessment || isSurvey) && !fromTraining" (click)="
                    gotoUrl(
                      (isAssessment ? '/assessment/results/' : '/survey/results/') +
                        survey._id,
                      '',
                      true
                    )
                  " class="btn add-logo" pTooltip="{{ 'Results' | translator }}" tooltipPosition="right">

                  <img class="add-btn-img" src="../././../../.././../assets/icones-2025/result.png" alt="loading">
                </button>
                <button [hidden]="survey.accessType=='POPUP'" *ngIf="isAssessment || isSurvey"
                  (click)="copyURL('/sa/' + from + '/attempt/' + survey._id)" class="btn add-logo">

                  <img pTooltip="{{ 'Copy Link' | translator }}" tooltipPosition="right" class="add-btn-img"
                    src="../././../../.././../assets/icones-2025/Group-61513.png" alt="loading">
                </button>
                <button [hidden]="survey.accessType=='POPUP'" *ngIf="isAssessment"
                  (click)="showAutoQuestionModal = true" class="btn add-logo">

                  <img pTooltip="{{ 'Auto Question' | translator }}" tooltipPosition="right" class="add-btn-img"
                    src="../././../../.././../assets/icones-2025/auto-question.png" alt="loading">
                </button>
                <button [hidden]="survey.accessType=='POPUP'" class="btn add-logo" target="_blank" *ngIf="!isTopic && !fromTraining"
                  (click)="gotoUrl('/sa/' + from + '/attempt/' + survey._id, '', true)"
                  pTooltip="{{ 'an offer' | translator }}" tooltipPosition="right">

                  <img class="add-btn-img" src="../././../../.././../assets/icones-2025/Group-61515.png" alt="loading">
                </button>
                <button pTooltip="{{ 'Set Reminder' | translator }}" tooltipPosition="right"
                  [hidden]="survey.accessType=='POPUP'"
                  *ngIf="(startDate.getTime() != todayDate.getTime() && startDate.getTime() != tomorrow.getTime()) && (isAssessment || isSurvey)"
                  class="btn add-logo" (click)="showReminderModal = true">
                  <img class="add-btn-img" src="../././../../.././../assets/icones-2025/pending_actions.png"
                    alt="loading">
                </button>
              </div>
            </div>
          </div>
          <div class="col-md-5 col-12 p-1 slide-left mob-top" *ngIf="sidebarVisible">
            <div class="d-flex justify-content-start w-100">
              <div class="w-100 d-flex justify-content-center question-ov-flow">
                <div class="w-100">
                  <!-- side bar code start -->
                  <div class="question-ov-flow p-l-2">
                    <div class="v4-sidebar">
                      <div class="container-fluid pos-rel p-0">
                        <div class="assesment-cross">
                          <div (click)="closeSidebar()"><i class="fa-solid fa-xmark"></i></div>
                        </div>
                        <p-tabView class="ui-tabview v4-dsbrd-btns" [activeIndex]="0">
                          <p-tabPanel class="v4-dsbrd-btns ui-tabview" header="{{ 'Questions' | translator }}">
                            <div class="row">
                              <div class="col-md-6 col-12 p-0 my-1" *ngFor="let category of questionBank">
                                <ng-container *ngIf="category.category != 'Impact Measurement'">
                                  <label class="items-label">{{
                                    category.category | translator
                                    }}</label>
                                  <div class="px-2" *ngFor="let question of category.questions">
                                    <ng-container *ngIf="
                                isSurvey || !questionsHideAssessment.includes(question.type)
                              ">
                                      <label (click)="addQuestion(question, true, false)" class="items d-flex">
                                        <i aria-hidden="true" style="font-size: 1.2rem"
                                          class="{{ getIconClass(question.icon) }} mx-2">
                                        </i>
                                        <span class="side-nav-tab">{{ question.name | translator }}</span>
                                      </label>
                                    </ng-container>
                                  </div>
                                </ng-container>
                              </div>
                            </div>
                          </p-tabPanel>
                          <p-tabPanel header="{{ 'Topics' | translator }}" *ngIf="isAssessment">
                            <div class="d-flex justify-content-center">
                              <h5 class="heading textt-900 mt-2 tab" [class.active]="QBTab === 'Service'"
                                (click)="ChangeQBTab('Service', $event)">
                                {{ "Service" | translator }}
                              </h5>
                              <h5 class="heading textt-900 mx-2 mt-2 tab" [class.active]="QBTab === 'Topic'"
                                (click)="ChangeQBTab('Topic', $event)">
                                {{ "Topic" | translator }}
                              </h5>
                            </div>
                            <div *ngIf="QBTab == 'Service'">
                              <div class="d-flex justify-content-start align-items-baseline gap-2 w-100">
                                <div class="d-flex gap-2 w-100">
                                  <p-dropdown class="w-100 ppp-dropdown" [options]="ministries"
                                    [(ngModel)]="dropMinistry" optionLabel="label" appendTo="body"
                                    (onChange)="onChangeDropdown()"
                                    [placeholder]="'Select Ministry' | translator"></p-dropdown>
                                  <p-dropdown class="w-100 ppp-dropdown" [options]="types" [(ngModel)]="dropType"
                                    optionLabel="label" appendTo="body" (onChange)="onChangeDropdown()"
                                    [placeholder]="'Select Type' | translator"></p-dropdown>
                                </div>
                                <button class="v4-btn-every m-2 py-2" (click)="resetFilters()">
                                  <i class="pi pi-refresh"></i>
                                </button>
                              </div>
                              <div *ngIf="filteredQBService && filteredQBService.length <= 0" class="mt-2">
                                <app-no-data></app-no-data>
                              </div>
                              <div class="row w-100" *ngIf="filteredQBService && filteredQBService.length > 0">
                                <div *ngFor="let topic of filteredQBService">
                                  <div class="data-capsoules" (click)="
                              topic.questions == undefined
                                ? null
                                : addTopicQuestion(topic.questions)
                            ">
                                    <div class="d-flex flex-column gap-2 w-100">
                                      <div class="minisbutton d-flex justify-content-between gap-2">
                                        <div class="d-flex gap-2" *ngIf="topic?.data[0]?.ministry?.label">
                                          <img src="{{
                                      staticFileUrl + topic?.data[0]?.ministry?.icon
                                    }}" class="ministry-logo" />
                                          <h5 class="miniheading">
                                            {{ topic?.data[0]?.ministry?.label }}
                                          </h5>
                                        </div>
                                        <div class="cap-nums mx-2">
                                          {{
                                          topic.questions == undefined
                                          ? 0
                                          : topic.questions.length
                                          }}
                                        </div>
                                      </div>
                                      <div class="cap-text">{{ topic.name }}</div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div *ngIf="QBTab == 'Topic'">
                              <div class="d-flex justify-content-start align-items-baseline gap-2 w-100 222">
                                <div class="d-flex gap-2 w-100">
                                  <p-dropdown class="w-100 ppp-dropdown" [options]="topics" [(ngModel)]="dropTopic"
                                    optionLabel="name" appendTo="body" (onChange)="onChangeDropdown()"
                                    [placeholder]="'Select Topic' | translator"></p-dropdown>
                                  <p-dropdown class="w-100 ppp-dropdown" [options]="types" [(ngModel)]="dropType"
                                    optionLabel="label" appendTo="body" (onChange)="onChangeDropdown()"
                                    [placeholder]="'Select Type' | translator"></p-dropdown>
                                </div>
                                <button class="v4-btn-every m-2 py-2" (click)="resetFilters()">
                                  <i class="pi pi-refresh"></i>
                                </button>
                              </div>
                              <div *ngIf="filteredQBTopics && filteredQBTopics.length <= 0" class="mt-2">
                                <app-no-data></app-no-data>
                              </div>
                              <div class="row w-100" *ngIf="filteredQBTopics && filteredQBTopics.length > 0">
                                <div *ngFor="let topic of filteredQBTopics">
                                  <div class="data-capsoules" (click)="
                              topic.questions == undefined
                                ? null
                                : addTopicQuestion(topic.questions)
                            ">
                                    <div class="d-flex flex-column gap-2 w-100">
                                      <div class="minisbutton d-flex justify-content-between gap-2">
                                        <div class="d-flex align-items-center gap-2"
                                          *ngIf="topic?.questionBankTopic[0]?.name">
                                          <h5 class="miniheading">
                                            {{ topic?.questionBankTopic[0]?.name }}
                                          </h5>
                                        </div>
                                        <div class="cap-nums mx-2">
                                          {{
                                          topic.questions == undefined
                                          ? 0
                                          : topic.questions.length
                                          }}
                                        </div>
                                      </div>
                                      <div class="cap-text">{{ topic.name }}</div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </p-tabPanel>
                        </p-tabView>
                      </div>
                    </div>
                  </div>
                  <!-- side bar code end -->

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- side bar code end -->

</div>

<!-- Footer and Thankyou page modal -->
<p-dialog [blockScroll]="true" [draggable]="false" header="Header" [(visible)]="openModal"
  [style]="{ width: '95vw', maxWidth: '1700px' }">
  <ng-template pTemplate="header">
    <span class="text-xl font-bold">
      {{
      footerModal
      ? ("Update footer" | translator)
      : ("Update the thank you page text" | translator)
      }}
    </span>
  </ng-template>
  <p-editor plainTextPaste class="question-p-editor-white 111" #editor [(ngModel)]="editorText" (onTextChange)="setText($event)"
    [style]="{ height: '320px' }"></p-editor>
  <ng-template pTemplate="footer">
    <button class="v4-btn-every" (click)="closeModal()"><i class="pi pi-check m-l-2"></i>{{'OK' | translator}}</button>
  </ng-template>
</p-dialog>

<!-- Add externals modal -->
<p-dialog [blockScroll]="true" [draggable]="false" header="Header" [(visible)]="openAddExternalModal"
  [style]="{ width: '95vw', maxWidth: '1200px' }">
  <ng-template pTemplate="header">
    <span class="text-xl font-bold">{{
      "Add external users" | translator
      }}</span>
  </ng-template>
  <ng-template pTemplate="body">
    <div class="p-fluid w-100">
      <label class="mb-3 color-grey" for="externals">{{
        "Add emails survey" | translator
        }}</label>
      <p-chips [(ngModel)]="survey.externals" [addOnBlur]="true" [addOnTab]="true" name="externals" #externalMailChips
        class="p-chipp" (paste)="handlePaste($event)">
      </p-chips>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <button class="v4-btn-every" (click)="openAddExternalModal = false"><i class="pi pi-check m-l-2"></i>{{ 'Finished' |
      translator }}</button>
  </ng-template>
</p-dialog>

<!-- Setings Modal -->
<p-dialog [blockScroll]="true" [draggable]="false" header="Header" [(visible)]="openSettingsModal"
  [style]="{ width: '95vw', maxWidth: '1000px' }">
  <ng-template pTemplate="header">
    <span class="text-xl font-bold">{{ "Survey Settings" | translator }}</span>
  </ng-template>
  <ng-template pTemplate="body">
    <div class="d-flex flex-wrap gap-2 mb-4">
      <button *ngIf="isAssessment" (click)="openGradesEditor()" class="btn v4-btn-every">
        {{ "Grades" | translator }}
      </button>
      <button *ngIf="isAssessment" (click)="openCertificateTextModal = true;" class="btn v4-btn-every">
        {{ "Certificate Text" | translator }}
      </button>
      <button *ngIf="isAssessment" (click)="gotoUrl('/assessment/certificate/' + survey._id + '/' + email, '', true)"
        class="btn v4-btn-every">
        {{ "View Certificate" | translator }}
      </button>
      <button (click)="openExternalFieldsModal = true" class="btn v4-btn-every">
        {{ "External User Fields" | translator }}
      </button>
    </div>
    <div class="d-flex column gap-1 align-items-start justify-content-start 1111" *ngIf="isAssessment" class="">
      <div class="d-flex align-items-center gap-1" style="margin-top: 1.5rem">
        <p-checkbox class="border m-l-2" name="showCert" inputId="showCert" [binary]="true"
          [(ngModel)]="survey.showCert"></p-checkbox>
        <label class="color-grey" for="showCert">{{
          "Show Option to View Certificate on Profile Page" | translator
          }}</label>
      </div>
    </div>
    <div class="d-flex column gap-1 align-items-start justify-content-start" style="margin-bottom: 15px;"
      *ngIf="isAssessment" class="">
      <div class="d-flex align-items-center gap-1" style="margin-top: 1.5rem">
        <p-checkbox class="border m-l-2" name="showResult" inputId="showResult" [binary]="true"
          [(ngModel)]="survey.showResult"></p-checkbox>
        <label class="color-grey" for="showResult">{{
          "Show Option to View Results on Profile Page" | translator
          }}</label>
      </div>
    </div>
    <div class="d-flex flex-column gap-2 w-100 align-items-start justify-content-center">
      <label class="color-grey" [htmlFor]="'view-mode'">{{ "Display Mode" | translator }}: </label>
      <p-selectButton class="v4-selectbutton" id="view-mode" [options]="displayModes"
        [(ngModel)]="survey.settings.displayMode" optionLabel="label" optionValue="value"></p-selectButton>
    </div>
    <div class="p-fluid w-100 mt-2">
      <h5 class="mb-3">{{
        "Question Topics" | translator
        }}</h5>

      <p-tree class="question-p-tree" [value]="survey.topics" selectionMode="single" [(selection)]="selectedNode"
        (onNodeSelect)="toggleSelection($event)"
        emptyMessage="{{'No question classification created' | translator}}">
      
        <ng-template let-node pTemplate="default">
          <div class="d-flex align-items-center justify-content-between w-100">
          <span class="slide-down">{{ node.label }}</span>
         <button *ngIf="selectedNode === node" pButton icon="pi pi-trash" class="p-button-rounded p-button-danger p-button-text ml-2 slide-down" (click)="deleteNode(node)"></button>
          </div>
        </ng-template>

      </p-tree>

      <div class="mt-3 flex items-center gap-2">
        <input pInputText type="text" [(ngModel)]="newNodeData"
          placeholder="{{'enter question classification name' | translator }}"
          class="q-input-white mb-3 p-inputtext-sm" />
        <button class="v4-btn-every" (click)="addNode()"><i class="pi pi-plus m-l-2"></i>{{'Add new question topic' |
          translator }}</button>
      </div>
    </div>


  </ng-template>
  <ng-template pTemplate="footer">
    <button class="v4-btn-every" (click)="openSettingsModal = false; saveProgress(true,false)"><i
        class="pi pi-check m-l-2"></i>{{'OK' | translator}}</button>
  </ng-template>
</p-dialog>

<!-- Reorder Modal -->
<p-dialog [blockScroll]="true" [draggable]="false" header="Header" [(visible)]="openReorderModal"
  [style]="{ width: '95vw', maxWidth: '1200px' }">
  <ng-template pTemplate="header">
    <span class="text-xl font-bold">{{ "Rearrangement" | translator }}</span>
  </ng-template>
  <ng-template pTemplate="body">
    <div class="w-100">
      <table cdkDropList (cdkDropListDropped)="drop($event)" class="w-100 tab-table">
        <tr class="w-100" cdkDrag *ngFor="let rowData of orderableList; let index = index">
          <td style="width: 100px;" class="text-center">
            <span class="pi pi-bars tab-td"></span>
          </td>
          <td class="d-flex flex-row justify-content-between align-items-center w-100 tab-td-div">
            <div>
              <span class="mx-2">[{{ rowData.questionCode }}]</span>
              <span>{{
                rowData.questionText || rowData.meta.fields[0].label
                }}</span>
            </div>
            <div class="d-flex align-items-center justify-content-center">
              <div class="tab-td-num-box">{{ rowData.index }}</div>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <button class="v4-btn-every" (click)="saveOrder()"><i class="pi pi-check m-l-2"></i>{{ 'OK' | translator }}</button>
  </ng-template>
</p-dialog>

<!-- Add Question from Topic Modal -->
<p-dialog [blockScroll]="true" [draggable]="false" [header]="'Add Question from Topic' | translator"
  [(visible)]="openTopicQAddModal" [style]="{ width: '95vw', maxWidth: '1200px' }">
  <ng-template pTemplate="body">
    <div class="w-100">
      <!-- Filter by difficulty level dropdown -->
      <div class="d-flex flex-column align-items-start justify-content-start">
        <label>{{ "Difficulty Level" | translator }}</label>
        <p-dropdown appendTo="body" [options]="difficultyLevels" (onChange)="filterTopicQuestions($event)"></p-dropdown>
      </div>
      <!-- "Select All" Checkbox -->
      <div>
        <input type="checkbox" id="selectAllCheckbox" name="selectAllCheckbox" [(ngModel)]="selectAllQuestions"
          (change)="toggleSelectAll()" class="checkbox" />
        <label for="selectAllCheckbox" class="p-20" style="cursor: pointer">{{
          "Select All" | translator
          }}</label>
      </div>

      <!-- Question List -->
      <div *ngFor="let question of filteredTopicQuestions; let i = index">
        <ng-container *ngIf="isSurvey || !questionsHideAssessment.includes(question.type)">
          <div class="question-container">
            <!-- Individual Question Checkbox -->
            <div class="d-flex align-items-center">
              <div>
                <input type="checkbox" [(ngModel)]="selectedQuestions[question._id]"
                  (click)="SaveQuestionsToAdd(question._id)" class="checkbox" />
              </div>
              <div class="w-100">
                <app-questions-edit [disabled]="true" [editingIndex]="editingIndex"
                  [conditionalQuestions]="conditionalQuestions" [question]="question" [questionIndex]="i"
                  [removeQuestion]="removeQuestion" [disableConditionalOptions]="disableConditionalOptions"
                  [getConditionalOptions]="getConditionalOptions" [isAssessment]="isAssessment" [isTopic]="isTopic"
                  [survey]="survey" [fromTraining]="fromTraining" (saveProgress)="saveProgress()"
                  [isImpactSurvey]="isImpactSurvey" [difficultyLevels]="difficultyLevels"></app-questions-edit>
              </div>
            </div>
            <!-- position under bar with buttons custom code start -->
            <div class="pos-rel">
              <div class="hrr"></div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <p-button (onClick)="confirmAddTopicQuestions()" label="{{ 'OK' | translator }}" icon="pi pi-check"></p-button>
  </ng-template>
</p-dialog>

<!-- Add Question to Topic Modal -->
<p-dialog [blockScroll]="true" [draggable]="false" [header]="'Add Question to Topic and Assessment' | translator"
  [(visible)]="openQAddModal" [style]="{ width: '95vw', maxWidth: '1200px' }">
  <ng-template pTemplate="body">
    <p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
    <div class="w-100">
      <div class="w-100">
        <app-questions-edit [disabled]="false" [editingIndex]="-2" [conditionalQuestions]="conditionalQuestions"
          [question]="questionsToTopic" [questionIndex]="-2" [removeQuestion]="null"
          [disableConditionalOptions]="disableConditionalOptions" [getConditionalOptions]="getConditionalOptions"
          [isAssessment]="isAssessment" [isTopic]="isTopic" [survey]="survey" [fromTraining]="fromTraining"
          (saveProgress)="saveProgress()" [isImpactSurvey]="isImpactSurvey"
          [difficultyLevels]="difficultyLevels"></app-questions-edit>
        <!-- position under bar with buttons custom code start -->
        <div class="pos-rel">
          <div class="hrr"></div>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <p-button (onClick)="confirmAddQuestionTopic()" label="{{ 'OK' | translator }}" icon="pi pi-check"></p-button>
  </ng-template>
</p-dialog>

<p-dialog [blockScroll]="true" [draggable]="false" header="{{ 'Select Service' | translator }}" [maximizable]="true"
  [(visible)]="showSelectServiceModal" [style]="{ width: '95vw', maxWidth: '1700px', maxHeight: '900px' }">
  <div class="custum-card">
    <app-select-service (currentDataItem)="setServiceLink($event)"></app-select-service>
  </div>
</p-dialog>

<p-dialog [blockScroll]="true" [draggable]="false" [header]="'Grades Criteria' | translator" [maximizable]="true"
  [(visible)]="openGradesModal" (onHide)="onGradesModalHide()" [style]="{ width: '95vw', maxWidth: '1200px' }">
  <div *ngFor="let criteria of survey.percentageCriteria; let i = index">
    <div class="my-3 row">
      <div class="col-md-3 col-12 column">
        <label class="label-txt font-bold p-1 color-grey 111">{{
          "Grade Title" | translator
          }}</label>
        <input class="q-input-white" placeholder="Title" type="text" [(ngModel)]="criteria.title" pInputText
          [disabled]="!!criteria.editable ? false : true" />
      </div>
      <div class="col-md-2 col-6 column">
        <label class="label-txt font-bold p-1 color-grey 222">{{
          "From" | translator
          }}</label>
        <p-inputNumber class="q-input-number-2" [(ngModel)]="criteria.from"
          [disabled]="!!criteria.editable ? false : true" [inputStyle]="{
          'width': '50%',
        }"></p-inputNumber>
      </div>
      <div class="col-md-2 col-6 column">
        <label class="label-txt font-bold p-1 color-grey 333">{{
          "To" | translator
          }}</label>
        <p-inputNumber class="q-input-number-2" [(ngModel)]="criteria.to"
          [disabled]="!!criteria.editable ? false : true" [inputStyle]="{
          'width': '50%',
        }"></p-inputNumber>
      </div>
      <div class="col-md-5 col-12 column">
        <div class="d-flex align-items-end w-100">
          <div class="column w-100 m-l-2">
            <label class="label-txt font-bold p-1 color-grey 444">{{
              "Icon" | translator
              }}</label>
            <p-dropdown class="inpt-bg-4-modal custom-dropdown" appendTo="body" [options]="badgeOptions"
              [(ngModel)]="criteria.icon">
              <ng-template let-option pTemplate="item">
                <div class="badge-item">
                  <img [src]="'../../../assets/bg/certificate/' + option" alt="{{ option }}" style="width: 30px" />
                </div>
              </ng-template>
              <ng-template let-selectedOption pTemplate="selectedItem">
                <div class="badge-item">
                  <img [src]="'../../../assets/bg/certificate/' + selectedOption" alt="{{ selectedOption }}"
                    style="width: 30px" />
                </div>
              </ng-template>
            </p-dropdown>
          </div>
          <div class="pb-1">
            <p-button class="mb-1" [disabled]="survey.percentageCriteria.length == 1"
              styleClass="input-button p-button-rounded p-button-danger p-button-text"
              (onClick)="removePercentageCriteria(i)" icon="pi pi-trash"></p-button>
          </div>
        </div>
      </div>
    </div>
    <hr />
  </div>
  <p-button class="v4-plus" (onClick)="addNewPercentageCriteria()" icon="pi pi-plus"
    styleClass="p-button-rounded p-button-outlined"></p-button>
  <ng-template pTemplate="footer">
    <button class="v4-btn-every" (click)="openGradesModal = false;"><i class="pi pi-angle-right m-l-2"></i>{{'Back' |
      translator}}</button>
    <button class="v4-btn-every" (click)="commitGradesEditor()"><i
        class="pi pi-check m-l-2"></i>{{'Save' | translator}}</button>
  </ng-template>
</p-dialog>

<p-dialog [blockScroll]="true" [draggable]="false" [header]="'Certificate Text' | translator" [maximizable]="true"
  [(visible)]="openCertificateTextModal" [style]="{ width: '95vw', maxWidth: '1200px' }">
  <p-tabView class="ui-tabview v4-dsbrd-btns" [activeIndex]="0">
    <p-tabPanel class="v4-dsbrd-btns ui-tabview" header="{{ 'Certificate without Ministry Questions' | translator }}">
      <div class="my-3 d-flex flex-column gap-3 align-items-start">
        <p-dropdown [options]="survey.percentageCriteria" [(ngModel)]="dropGrade" optionLabel="title" appendTo="body"
          (onChange)="onChangeGrade($event)" [placeholder]="'Select Grade' | translator">
        </p-dropdown>

        <label class="label-txt p-1 color-grey">{{
          "Certificate Top Text" | translator
          }}</label>
        <textarea class="text-area w-100" *ngIf="!!survey.percentageCriteria && survey.percentageCriteria[gradeIndex]?.certificateText" [(ngModel)]="
            survey.percentageCriteria[gradeIndex].certificateText.top
          " [required]="true" id="description">
        </textarea>

        <label class="label-txt p-1 color-grey">{{
          "Certificate Middle Text" | translator
          }}</label>
        <textarea class="text-area w-100" *ngIf="!!survey.percentageCriteria && survey.percentageCriteria[gradeIndex]?.certificateText" [(ngModel)]="
            survey.percentageCriteria[gradeIndex].certificateText.middle
          " [required]="true" id="description">
        </textarea>

        <label class="label-txt p-1 color-grey">{{
          "Certificate Bottom Text" | translator
          }}</label>
        <textarea class="text-area w-100" *ngIf="!!survey.percentageCriteria && survey.percentageCriteria[gradeIndex]?.certificateText" [(ngModel)]="
            survey.percentageCriteria[gradeIndex].certificateText.bottom
          " [required]="true" id="description">
        </textarea>
      </div>
    </p-tabPanel>
    <p-tabPanel header="{{ 'Certificate with Ministry Questions' | translator }}" *ngIf="!!survey.certificateMinistry">
      <ng-container *ngFor="let key of getKeys(survey.certificateMinistry)">
        <label class="label-txt p-1 color-grey">{{
          "Certificate " + key | translator
          }}</label>
        <textarea class="text-area w-100" [(ngModel)]="survey.certificateMinistry[key]" [required]="true"
          id="description-{{ key }}">
        </textarea>
      </ng-container>
    </p-tabPanel>
  </p-tabView>

  <ng-template pTemplate="footer">
    <button class="v4-btn-every" (click)="openCertificateTextModal = false;"><i
        class="pi pi-angle-right m-l-2"></i>{{'Back' | translator}}</button>
    <button class="v4-btn-every"
      (click)="openCertificateTextModal = false; openSettingsModal = false; saveProgress(true,false)"><i
        class="pi pi-check m-l-2"></i>{{'Save' | translator}}</button>
  </ng-template>
</p-dialog>

<p-dialog [blockScroll]="true" [draggable]="false" [header]="'Automatic Question Generator' | translator"
  [(visible)]="showAutoQuestionModal" [style]="{ width: '95vw', maxWidth: '1200px' }">
  <ng-template pTemplate="body">
    <p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
    <div class="w-100">
      <div class="w-100">
        <div class="d-flex column gap-1 align-items-start justify-content-start mt-2 11">
          <span class="ans-color">{{ "Select OU" | translator }}</span>
          <input class="q-input-white" [(ngModel)]="selectedOusLabel" type="text" [readonly]="true"
            (click)="openSelectOUModal = true" />
        </div>
        <div class="d-flex column gap-1 align-items-start justify-content-start">
          <span class="ans-color">{{ "Topics" | translator }}</span>
          <div class="w-100">
            <p-multiSelect class="ppp-multi-select" [options]="filterQuestionBankAll"
              [placeholder]="'Any Topic' | translator" [(ngModel)]="selectedQBs" optionLabel="name" optionValue="_id"
              appendTo="body" display="chip">
            </p-multiSelect>
          </div>
        </div>
        <div class="d-flex column gap-1 align-items-start justify-content-start mt-2">
          <span class="ans-color">{{ "Difficulty Level" | translator }}</span>
          <div class="w-100">
            <p-multiSelect class="ppp-multi-select" [options]="difficultyLevels"
              [placeholder]="'Any Difficulty Level' | translator" [(ngModel)]="selectedLevels" optionLabel="label"
              optionValue="value" appendTo="body" display="chip">
            </p-multiSelect>
          </div>
        </div>
        <div class="d-flex column gap-1 align-items-start justify-content-start mt-2">
          <span class="ans-color">{{ "Question Type" | translator }}</span>
          <div class="w-100">
            <p-multiSelect class="ppp-multi-select" [options]="questionTypes"
              [placeholder]="'Any Question Type' | translator" [(ngModel)]="selectedTypes" optionLabel="name"
              optionValue="type" appendTo="body" display="chip">
            </p-multiSelect>
          </div>
        </div>
        <div class="d-flex column gap-1 align-items-start justify-content-start mt-2 w-100">
          <span class="ans-color">{{ "No. of Question" | translator }}</span>
          <p-inputNumber inputId="integeronly" class="q-input-number-2 w-100" [(ngModel)]="questionLimit" [max]="100" />
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <button class="v4-btn-every" (click)="generateQuestions()"><i class="pi pi-check m-l-2"></i>{{ 'Generate' |
      translator }}</button>
  </ng-template>
</p-dialog>

<p-dialog [blockScroll]="true" [draggable]="false" [header]="'Select OU' | translator" [maximizable]="true"
  [(visible)]="openSelectOUModal" [style]="{ width: '95vw', maxWidth: '1200px' }">
  <div class="d-flex justify-content-center" *ngIf="selectedOus" style="width: 441px;">
    <p-treeSelect [options]="selectedOus" appendTo="body" selectionMode="multiple" [metaKeySelection]="false"
      class="w-md-20rem w-100 custom-tree" containerStyleClass="w-100" (selectionChange)="ouChanged($event)"
      (onNodeSelect)="null" filterPlaceholder="{{ 'Search filter' | translator }}" [(ngModel)]="selectedTreeData"
      [filter]="true">
      <ng-template let-node pTemplate="default">
        <div class="d-flex" [ngClass]="
              selectedOus && selectedOus.includes(node) ? 'selectedNode' : ''">
          <img *ngIf="checkisImg(node.data); else elseBlock" src="{{ staticURL }}{{ node.data }}"
            class="img-fluid p-1 tree-img-bg" style="max-height: 30px; max-width: 30px" />
          <ng-template #elseBlock>
            <i class="{{ node.data }} p-2" style="font-size: 1rem"></i>
          </ng-template>
          <b class="text-nowrap">{{ node.label }}</b>
        </div>
      </ng-template>
    </p-treeSelect>
  </div>
  <ng-template pTemplate="footer">
    <p-button class="v4-plus" [label]="'Select' | translator" icon="pi pi-check"
      (onClick)="openSelectOUModal = false;"></p-button>
  </ng-template>
</p-dialog>

<!-- Add Question from Topic Modal -->
<p-dialog [blockScroll]="true" [draggable]="false" [header]="'External User Fields' | translator"
  [(visible)]="openExternalFieldsModal" [maximizable]="true" [style]="{ width: '95vw' , maxWidth:'1200px'}">
  <ng-template pTemplate="body">
    <app-skelitions [hidden]="!skelition" [value]="1" class="mb-2"></app-skelitions>
    <div class="w-100" *ngIf="!skelition">
      <div class="d-flex justify-content-center mb-3 mt-3">
        <div class="d-flex align-items-center gap-2 w-100">
          <p-dropdown class="w-100 ppp-dropdown-white" appendTo="body" [options]="externalFieldQuestionTypeOptions"
            [(ngModel)]="externalFieldSelectedQuestionType" optionLabel="label" optionValue="value"
            [placeholder]="'Select Question Type' | translator"></p-dropdown>
            <div>
              <button class="btn add-question mob-view"
                (click)="additionIndex = 0; addQuestion(externalFieldSelectedQuestionType || questionBank[0].questions[0], true, false); editingIndex = 0">
              {{ "Add a question" | translator }}
              </button>
            </div>
        </div>
      </div>
      <!-- Second i should be replaced with editingIndex after implementing recognizing mechonizam -->
      <div *ngFor="let question of survey.externalQuestions; let i = index">
        <div>
          <app-questions-edit (click)="setCurrentEditQuestion(i)" [editingIndex]="editingIndex" [question]="question"
            [questionIndex]="i" [removeQuestion]="removeQuestion" [conditionalQuestions]="conditionalQuestions"
            [disableConditionalOptions]="disableConditionalOptions" [getConditionalOptions]="getConditionalOptions"
            [isAssessment]="isAssessment" [isTopic]="isTopic" [survey]="survey" [fromTraining]="fromTraining" 
            (saveProgress)="saveProgress()" [UserExternalFields]="true" [difficultyLevels]="difficultyLevels"
            [ouTreeOptions]="ouTreeOptionsForQuestions" [availableOuTreeTags]="availableOuTreeTags"></app-questions-edit>
          <!-- position under bar with buttons custom code start -->
          <div class="pos-rel">
            <div class="flex-center my-3">
              <div class="d-flex align-items-center gap-2 w-100">
                <p-dropdown class="w-100 ppp-dropdown-white" appendTo="body" [options]="externalFieldQuestionTypeOptions"
                  [(ngModel)]="externalFieldSelectedQuestionType" optionLabel="label" optionValue="value"
                  [placeholder]="'Select Question Type' | translator"></p-dropdown>
                  <div>
                    <button class="btn add-question mob-view"
                      (click)="additionIndex = i + 1; addQuestion(externalFieldSelectedQuestionType || questionBank[0].questions[0], true, false); editingIndex = i + 1">
                    {{ "Add a question" | translator }}
                    </button>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <button class="v4-btn-every" (click)="openExternalFieldsModal = false;"><i
        class="pi pi-angle-right m-l-2"></i>{{'Back' | translator}}</button>
    <button class="v4-btn-every" (click)="saveProgress(true,false)"><i class="pi pi-check m-l-2"></i>{{ 'save' |
      translator }}</button>
  </ng-template>
</p-dialog>

<p-dialog [blockScroll]="true" [draggable]="false" header="{{'Set Reminder' | translator}}" [maximizable]="true"
  [(visible)]="showReminderModal" [style]="{ width: '95vw', maxWidth: '1700px', maxHeight: '900px' }">
  <div>
    <app-reminder-modal *ngIf="showReminderModal" (close)="showReminderModal = false" [_id]="survey._id"
      [startDate]="survey.startDate" [type]="isAssessment ? 'ASSESSMENT' : 'SURVEY'"></app-reminder-modal>
  </div>
  <ng-template pTemplate="footer">
  </ng-template>
</p-dialog>

<app-footer *ngIf="!fromTraining"></app-footer>